import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AuthService } from './auth.service';
import { ApiService } from './api.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './app.html',
  styleUrls: ['./app.css']
})

export class App {

  menuOpen = false;

  mobileNumber: string = '';

  otp: string = '';

  fullName = '';

  email = '';

  city = '';

  pincode = '';

  businessType = '';

  investmentAmount = '';

  message = '';

  otpSent = false;

  verified = false;

  countdown = 60;

  resendDisabled = true;

  interval: any;

  constructor(
  private authService: AuthService,
  private apiService: ApiService
) {}

  async sendOTP() {

    if (!this.mobileNumber) {

      alert('Enter Mobile Number');

      return;
    }

    try {

      let number =
        String(this.mobileNumber)
        .replace(/\D/g, '');

      if (number.length !== 10) {

        alert('Enter Valid Mobile Number');

        return;
      }

      const phoneNumber = `+91${number}`;

      console.log(phoneNumber);

      await this.authService.sendOTP(phoneNumber);

      this.otpSent = true;

      this.startTimer();

      alert('OTP Sent Successfully');

    } catch (error) {

      console.error(error);

      alert('Failed To Send OTP');
    }
  }

  async verifyOTP() {

    if (!this.otp) {

      alert('Enter OTP');

      return;
    }

    try {

      await this.authService.verifyOTP(this.otp);

      this.verified = true;

      this.otpSent = false;

      clearInterval(this.interval);

      alert('Mobile Number Verified');

    } catch (error) {

      console.error(error);

      alert('Invalid OTP');
    }
  }

  startTimer() {

    this.countdown = 60;

    this.resendDisabled = true;

    clearInterval(this.interval);

    this.interval = setInterval(() => {

      this.countdown--;

      if (this.countdown <= 0) {

        clearInterval(this.interval);

        this.resendDisabled = false;
      }

    }, 1000);
  }

  async resendOTP() {

    if (this.resendDisabled) return;

    this.otpSent = false;

    await this.sendOTP();
  }

    submitForm() {

  if (!this.verified) {

    alert('Please Verify Mobile Number');

    return;
  }

  const formData = {

  fullName: this.fullName,

  mobileNumber: String(this.mobileNumber),

  email: this.email,

  city: this.city,

  pincode: this.pincode,

  businessType: this.businessType,

  investmentAmount: this.investmentAmount,

  message: this.message
};

console.log(formData);
console.log('FORM DATA =>', formData);
console.log('TYPE =>', typeof formData.mobileNumber);
console.log('JSON =>', JSON.stringify(formData));

  this.apiService
    .saveConsultation(formData)
    .subscribe({

      next: (res) => {

        alert('Form Submitted Successfully');

        console.log(res);
      },

      error: (err) => {

  console.log('FULL ERROR =>');
  console.log(err);

  console.log('STATUS =>');
  console.log(err.status);

  console.log('ERROR BODY =>');
  console.log(err.error);

  alert('Failed To Submit Form');
}
    });
}
  
}